// How many wrapped lines a row of flex items has landed on. No DOM API reports this, so measure:
// under `align-items: center` every item on a line shares a vertical centre, so the centres cluster
// one group per line. The tolerance absorbs the sub-pixel spread within a line.
const ROW_CLUSTER_TOLERANCE_PX = 4;

export function countFlexRows(items: HTMLElement[]): number {
  const centres = items
    .map((item) => {
      const rect = item.getBoundingClientRect();
      return rect.top + rect.height / 2;
    })
    .sort((a, b) => a - b);

  let rows = 0;
  let last: number | null = null;

  centres.forEach((centre) => {
    if (last === null || Math.abs(centre - last) > ROW_CLUSTER_TOLERANCE_PX) rows += 1;
    last = centre;
  });

  return rows;
}
